import api from './api';

export const getMyInvites = async () => {
  const { data } = await api.get('/invites/mine');
  return data;
};

export const acceptInvite = async (inviteId) => {
  const { data } = await api.post(`/invites/${inviteId}/accept`);
  return data;
};

export const declineInvite = async (inviteId) => {
  const { data } = await api.post(`/invites/${inviteId}/decline`);
  return data;
};

export default {
  getMyInvites,
  acceptInvite,
  declineInvite,
};
